<template>
	<!-- make retain-focus false to enable clipboard.js -->
	<v-dialog
			persistent
			:retain-focus="false"
			v-model="show_"
			width="750px">
		<template v-slot:activator="{ on }">
			<v-btn class="customVBtn" v-on="on">
				<v-row no-gutters align="end">
					<v-col class="center">
						<v-icon>cloud_upload</v-icon>
					</v-col>
					<v-col class="ml-2 center">
						<span class="button_">UPLOAD</span>
					</v-col>
				</v-row>
			</v-btn>
		</template>
		<v-card class="customVCard">
			<v-card-title>
				<v-row class="pt-2" justify="center">
					<v-col cols="auto">
						FILE UPLOADER
					</v-col>
				</v-row>
			</v-card-title>
			<v-card-text>
				<!-- tab -->
				<v-row class="px-2" align="center">
					<v-col>
						<v-tabs v-model="tab_" color="success">
							<v-tab>Upload</v-tab>
							<v-tab>Download</v-tab>
							<v-tab>Check</v-tab>
						</v-tabs>
					</v-col>
				</v-row>
				<!-- item -->
				<v-tabs-items v-model="tab_">
					<!-- upload -->
					<v-tab-item>
						<!-- text & csv -->
						<v-row class="px-2" align="center">
							<v-col>
								<v-file-input
										accept=".txt,.csv"
										color="success"
										hide-details
										label=".txt / .csv"
										multiple
										outlined
										:prepend-icon="null"
										show-size
										v-model="fileText_" />
							</v-col>
						</v-row>
						<!-- image -->
						<v-row class="px-2" align="center">
							<v-col>
								<v-file-input
										accept=".jpeg,.jpg,.png"
										color="success"
										hide-details
										label=".jpeg / .jpg / .png"
										multiple
										outlined
										:prepend-icon="null"
										show-size
										v-model="fileImage_" />
							</v-col>
						</v-row>
						<!-- video and pdf -->
						<v-row class="px-2" align="center">
							<v-col>
								<v-file-input
										accept=".mp4,.mov,.pdf"
										color="success"
										hide-details
										label=".mp4 / .mov / .pdf"
										outlined
										:prepend-icon="null"
										show-size
										v-model="fileOther_">
									<template v-slot:append>
										<template v-if="$_bldrFlInpt_uploadOverSize()">
											<v-tooltip left>
												<template v-slot:activator="{ on }">
													<v-icon color="error" v-on="on">error_outline</v-icon>
												</template>
												File size is too big. (Limited under 10MB)
											</v-tooltip>
										</template>
									</template>
								</v-file-input>
							</v-col>
						</v-row>
						<!-- alert info -->
						<template v-if="!isEmpty(uploadUrl_)">
							<v-row class="px-2" align="center">
								<v-col>
									<template v-for="(url, index) in uploadUrl_">
										<v-alert
												:key="index"
												text
												color="success">
											<v-row align="center" dense>
												<v-col>
													<pre	class="prettyprint caption prettySuccess_"
															v-text="url" />
												</v-col>
												<v-col cols="auto">
													<clipboard-button :text="url.url" />
												</v-col>
												<v-col cols="auto">
													<v-btn	class="customVBtn"
															icon
															@click="openLink({ url: url.url })">
														<v-icon>save_alt</v-icon>
													</v-btn>
												</v-col>
											</v-row>
										</v-alert>
									</template>
								</v-col>
							</v-row>
						</template>
					</v-tab-item>
					<!-- download -->
					<v-tab-item>
						<!-- file -->
						<v-row class="px-2" align="center">
							<v-col>
								<v-combobox
										v-model="fileTarget_"
										append-icon="refresh"
										color="success"
										:disabled="refreshing_"
										hide-details
										outlined
										:items="fileTargetItems_"
										@click:append="$_bldrFlInpt_refreshFileTargetItems" />
							</v-col>
						</v-row>
						<!-- alert info -->
						<template v-if="!isEmpty(downloadUrl_)">
							<v-row class="px-2" align="center">
								<v-col>
									<template v-for="(url, index) in downloadUrl_">
										<v-alert
												:key="index"
												text
												color="success">
											<v-row align="center" dense>
												<v-col>
													<pre	class="prettyprint caption prettySuccess_"
															v-text="url" />
												</v-col>
												<v-col cols="auto">
													<clipboard-button :text="url.url" />
												</v-col>
												<v-col cols="auto">
													<v-btn	class="customVBtn"
															icon
															@click="openLink({ url: url.url })">
														<v-icon>save_alt</v-icon>
													</v-btn>
												</v-col>
											</v-row>
										</v-alert>
									</template>	
								</v-col>
							</v-row>
						</template>
					</v-tab-item>
					<!-- check image -->
					<v-tab-item>
						<!-- url -->
						<v-row class="px-2" align="center">
							<v-col>
								<v-text-field
										v-model="checkImageUrl_"
										color="success"
										hide-details
										outlined
										placeholder="Image URL" />
							</v-col>								
						</v-row>
						<!-- image -->
						<template v-if="!isFalse(checkImageUrl_)">
							<v-row class="px-2" align="center">
								<v-col>
									<v-alert
											class="image_"
											color="success"
											outlined>
										<v-img	max-width="650px"
												contain
												:src="checkImageUrl_" />
									</v-alert>
								</v-col>
							</v-row>
						</template>
					</v-tab-item>
				</v-tabs-items>
			</v-card-text>
			<v-card-actions>
				<v-tabs-items v-model="tab_" class="buttons_">
					<!-- upload -->
					<v-tab-item>
						<v-row class="px-2 pb-3" justify="center" dense>
							<v-col cols="auto">
								<v-btn	class="customVBtn"
										block
										color="success"
										:disabled="$_bldrFlInpt_uploadEmpty() || $_bldrFlInpt_uploadOverSize()"
										large
										@click="$_bldrFlInpt_upload()">
									<template v-if="isFalse(uploading_)">
										Upload
									</template>
									<template v-else>
										<progress-circular />
									</template>
								</v-btn>
							</v-col>
							<v-col cols="auto">
								<v-btn	class="customVBtn"
										block
										color="secondary"
										large
										@click="$_bldrFlInpt_close()">
									Close
								</v-btn>
							</v-col>
						</v-row>
					</v-tab-item>
					<!-- download -->
					<v-tab-item>
						<v-row	class="px-2 pb-3"
								justify="center"
								dense>
							<v-col cols="auto">
								<v-btn	class="customVBtn"
										block
										color="success"
										:disabled="isFalse(fileTarget_)"
										large
										@click="$_bldrFlInpt_download()">
									Download
								</v-btn>
							</v-col>
							<v-col cols="auto">
								<v-btn	class="customVBtn"
										block
										color="secondary"
										large
										@click="$_bldrFlInpt_close()">
									Close
								</v-btn>
							</v-col>
						</v-row>
					</v-tab-item>
					<!-- check image -->
					<v-tab-item>
						<v-row class="px-2 pb-3" justify="center" dense>
							<v-col cols="auto">
								<v-btn	class="customVBtn"
										block
										color="secondary"
										large
										@click="$_bldrFlInpt_close()">
									Close
								</v-btn>
							</v-col>
						</v-row>
					</v-tab-item>
				</v-tabs-items>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	export default {
		name: 'BuilderFileInput',
		data() {
			return {
				tab_: 0,
				show_: false,
				// upload file
				fileText_: [],
				fileImage_: [],
				fileOther_: null,
				uploadUrl_: [],
				uploading_: false,
				// download file
				fileTarget_: null,
				fileTargetItems_: [],
				downloadUrl_: [],
				refreshing_: false,
				// tooltip
				showTooltipUploadText_: false,
				showTooltipUploadImage_: false,
				showTooltipDownload_: false,
				dataTooltipUploadText_: [],
				dataTooltipUploadImage_: [],
				dataTooltipDownload_: [],
				// check image
				checkImageUrl_: null
			}
		},
		computed: {
			$_bldrFlInpt_uploadEmpty() {
				const self_ = this;
				return () => {
					return self_.isEmpty(self_.fileText_) && self_.isEmpty(self_.fileImage_) && self_.isFalse(self_.fileOther_)
				}
			},
			$_bldrFlInpt_uploadOverSize() {
				const self_ = this;
				return () => {
					return !self_.isFalse(self_.fileOther_) && (self_.fileOther_.size > 10000000) // 10MB
				}
			}
		},
		created() {
			const self_ = this;

			self_.$_bldrFlInpt_refreshFileTargetItems()
		},
		methods: {
			$_bldrFlInpt_upload() {
				const self_ = this;

				self_.uploading_ = true;

				let promiseArray_ = []
				// text file
				if(!self_.isEmpty(self_.fileText_)) {
					self_.fileText_.forEach(file => {
						promiseArray_.push(self_.$_bldrFlInpt_uploadFileText(file))
					})
				}
				// image file
				if(!self_.isEmpty(self_.fileImage_)) {
					self_.fileImage_.forEach(file => {
						promiseArray_.push(self_.$_bldrFlInpt_uploadFileImage(file))
					})
				}
				// other file ( no multiple uplaod )
				if(!self_.isFalse(self_.fileOther_)) {
					promiseArray_.push(self_.$_bldrFlInpt_uploadFileOther(self_.fileOther_))
				}
				
				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return Promise.all(promiseArray_)
					}).then(() => {
						self_.fileText_ = []
						self_.fileImage_ = []
						self_.fileOther_ = null;

						self_.$_bldrFlInpt_refreshFileTargetItems()

						self_.uploading_ = false;
					})
				})
				
			},
			$_bldrFlInpt_uploadFileText(file) {
				const self_ = this;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.uploadFileText('Uploads', file.name, file)
					}).then(result => {
						self_.uploadUrl_.push({ name: result.name, url: result.url })
						resolve()
					}).catch(error => {
						reject(error)
					})
				})
			},
			$_bldrFlInpt_uploadFileImage(file) {
				const self_ = this;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.uploadFileImage('Uploads', file.name, file)
					}).then(result => {
						self_.uploadUrl_.push({ name: result.name, url: result.url })
						resolve()
					}).catch(error => {
						reject(error)
					})
				})
			},
			$_bldrFlInpt_uploadFileOther(file) { // only direct upload for other file
				const self_ = this;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.uploadFileOther('Uploads', file.name, file)
					}).then(result => {
						self_.uploadUrl_.push({ name: result.name, url: result.url })
						resolve()
					}).catch(error => {
						reject(error)
					})
				})
			},
			$_bldrFlInpt_download() {
				const self_ = this;

				let target_ = false;
				self_.fileTargetItems_.forEach(item => {
					if(self_.fileTarget_ == item) { target_ = true }
				})

				let path_ = null;
				if(target_) { path_ = 'uploads'; }
				else { path_ = ''; }

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.downloadFile(path_, self_.fileTarget_)
					}).then(result => {
						self_.downloadUrl_.push({ name: result.name, url: result.url })
						resolve()
					}).catch(error => {
						reject(error)
					})
				})
			},
			$_bldrFlInpt_refreshFileTargetItems() {
				const self_ = this;

				self_.refreshing_ = true;

				Promise.resolve().then(() => {
					return self_.getFileList('uploads')
				}).then(result => {
					self_.fileTargetItems_ = result;

					self_.refreshing_ = false;
				})
			},
			$_bldrFlInpt_close() {
				const self_ = this;

				self_.show_ = false;

				self_.fileText_ = []
				self_.fileImage_ = []
				self_.fileOther_ = null;
				self_.uploadUrl_ = []
				self_.uploading_ = false;

				self_.fileTarget_ = null;
				self_.downloadUrl_ = []

				self_.checkImageUrl_ = null;

				self_.$_bldrFlInpt_refreshFileTargetItems()
			}			
		}
	}
</script>

<style scoped>
	.button_ {
		font-size: xx-small !important;
	}
	.prettySuccess_ {
		border: none;
		color: #34a853;
		white-space: pre-wrap;
	}
	.prettyError_ {
		border: none;
		color: #ff5252;
		white-space: pre-wrap;
	}
	.buttons_ {
		width:100% !important;
	}
	.image_ {
		padding-left: 5px !important;
		padding-right: 5px !important;
	}
</style>
